function googleAddressPicker() {
    return Vue.component('googleaddresspicker', {
       
        props: ['value', 'options', 'text'],
        template: '<input class="form-control" v-model="value.fullAddress" autocomplete="off"></input>',        
      
        mounted: function () {
            this.$nextTick(function () {
                var self = this;
                var el = this.$el;
                self.options = self.options || { types: ['geocode'] };
              
                self.changed = function () {
                    self.googlePlace = self.autocomplete.getPlace();
                    self.googleAddressComponents = {};
                    self.address = { latitude: null, longitude: null, street: '', city: '', stateName: '', stateCode: '', zipCode: '', countryName: '', countryCode: '', fullAddress: '' };
                    if (self.googlePlace && self.googlePlace.address_components) {
                        for (var i = 0; i < self.googlePlace.address_components.length; i++) {
                            var component = self.googlePlace.address_components[i];
                            self.googleAddressComponents[component.types[0]] = component.long_name;
                            if (component.short_name)
                                self.googleAddressComponents[component.types[0] + '_code'] = component.short_name;

                        }
                    }
                    if (self.googleAddressComponents.administrative_area_level_1) self.address.stateName = self.googleAddressComponents.administrative_area_level_1;
                    if (self.googleAddressComponents.administrative_area_level_1_code && self.googleAddressComponents.administrative_area_level_1_code.length === 2) self.address.stateCode = self.googleAddressComponents.administrative_area_level_1_code;
                    if (self.googleAddressComponents.country) self.address.countryName = self.googleAddressComponents.country;
                    if (self.googleAddressComponents.country_code) self.address.countryCode = self.googleAddressComponents.country_code;
                    if (self.googleAddressComponents.locality) self.address.city = self.googleAddressComponents.locality;
                    if (self.googleAddressComponents.route) self.address.street = self.googleAddressComponents.route;
                    if (self.googleAddressComponents.street_number) self.address.street = [self.googleAddressComponents.street_number, self.address.street].join(' ');
                    if (self.googleAddressComponents.postal_code) self.address.zipCode = self.googleAddressComponents.postal_code;

                    if (self.googlePlace && self.googlePlace.formatted_address)
                        self.address.fullAddress = self.googlePlace.formatted_address;
                    if (self.googlePlace && self.googlePlace.geometry && self.googlePlace.geometry.location) {
                        console.log(self.googlePlace);
                        self.address.latitude = self.googlePlace.geometry.location.lat();
                        self.address.longitude = self.googlePlace.geometry.location.lng();
                    }

                    if (self.value) {
                        for (var key in self.address)
                            if (self.value[key] !== undefined) self.value[key] = self.address[key];
                    }

                    self.$emit('blur', self.value);
                };
                self.init = function () {
                    self.autocomplete = new google.maps.places.Autocomplete(el, self.options);
                    self.autocomplete.addListener('place_changed', self.changed);
                    el.addEventListener('blur', function () {
                        self.$emit('blur', self.value);
                    });
                    window.hasGoogleMapsAutocompleteLoaded = true;
                };

                if (window.hasGoogleMapsAutocompleteLoaded ||
                    (google && google.maps && google.maps.places)) self.init();
               
                if (window.attachEvent) {
                    window.attachEvent('onload', self.init);
                } else {
                    if (window.onload) {
                        var curronload = window.onload;
                        var newonload = function (evt) {
                            curronload(evt);
                            self.init();
                        };
                        window.onload = newonload;
                    } else {
                        window.onload = self.init;
                    }
                }
               
            });
        }
    });
}